import 'css-chunksrc/feature/cash-bank/CashBankView.module.scss';export default {
  "root": "CashBankView_root",
  "fullHeight": "CashBankView_fullHeight"
};